/**
 * Segmented progress bar with vertical bars
 * @param {Object} props
 * @param {Array} props.segments - Array of { value: number (0-100), color: string }
 * @param {number} props.totalBars - Number of vertical bars to display
 */
export default function SegmentedProgressBar({ segments = [], totalBars = 20, className }) {
    const getBars = () => {
        const bars = []

        for (let i = 0; i < totalBars; i++) {
            const barPosition = (i / totalBars) * 100
            let barColor = 'bg-gray-200'

            let accumulatedValue = 0
            for (const segment of segments) {
                accumulatedValue += segment.value
                if (barPosition < accumulatedValue) {
                    barColor = segment.color
                    break
                }
            }

            bars.push({ index: i, color: barColor })
        }

        return bars
    }

    const bars = getBars()

    return (
        <div className={`flex gap-1 h-6 w-full ${className || ''}`}>
            {bars.map((bar) => (
                <div
                    key={bar.index}
                    className={`flex-1 rounded-xs ${bar.color} transition-colors duration-200`}
                />
            ))}
        </div>
    )
}
